import React from "react";
import moment from "moment";
import { useIntl } from "react-intl";
import { Form, DatePicker } from "antd";

import {
  datePickerFormat,
  dateTimeApiFormat,
  dateTimeFormatForPrint,
} from "../../../../index";
import { setEndOfTheDay, setStartOfTheDay } from "../dateItem";

const { Item } = Form;
const { RangePicker } = DatePicker;

const dateTime = moment(moment.now());
const minDateTime = setStartOfTheDay(moment(moment.now()), true),
  maxDateTime = setEndOfTheDay(moment(moment.now()).add(2, "s"));

/**
 * vrátí hodnotu z výsledku RangePickerItem, pokud existuje, a vrátí řetězcovou reprezentaci
 * @param {[string]} value výsledek RangePickerItem
 * @param {number} idx index
 */
export function getDateFromRangePicker(value, idx) {
  return value && value.length > idx && value[idx]
    ? value[idx].format(dateTimeApiFormat)
    : undefined;
}

const RangePickerItem = ({
  getFieldDecorator,
  initialDateFrom,
  formItemLayout,
  initialDateTo,
  wrapperCol,
  showRanges,
  fieldName,
  disabled,
  showTime,
  labelCol,
  optional,
  message,
  future,
  label,
}) => {
  const intl = useIntl();
  return (
    <Item
      label={label}
      labelCol={labelCol ? { span: labelCol } : formItemLayout.labelCol}
      wrapperCol={wrapperCol ? { span: wrapperCol } : formItemLayout.wrapperCol}
    >
      {getFieldDecorator(fieldName, {
        initialValue: initialDateFrom
          ? [initialDateFrom, initialDateTo || dateTime]
          : undefined,
        rules: [
          {
            required: message && !optional,
            message,
          },
        ],
      })(
        <RangePicker
          showTime={showTime}
          disabled={disabled}
          ranges={
            showRanges
              ? {
                  [intl.formatMessage({
                    id: "messages.lastWeek",
                    defaultMessage: "Poslední týden",
                  })]: [moment().add(-7, "d"), moment()],
                  [intl.formatMessage({
                    id: "messages.lastMonth",
                    defaultMessage: "Poslední měsíc",
                  })]: [moment().add(-30, "d"), moment()],
                }
              : undefined
          }
          disabledDate={(d) =>
            !d || (future ? d.isBefore(minDateTime) : d.isAfter(maxDateTime))
          }
          format={showTime ? dateTimeFormatForPrint : datePickerFormat}
        />
      )}
    </Item>
  );
};

export default RangePickerItem;
